module.exports = __webpack_public_path__ + "static/media/logo-carolina.d93c77b3.png";